export const schoolProfileBullets = [
  {
    name: "Top menu - school search bar",
    description: `On the left side of the top menu, you'll see a link titled "Find a school by name". If you click on this, you can type your school's name and be linked directly to your school's profile page.`,
  },
  {
    name: "Top menu - Schools tab",
    description: `On the right side of the top menu, you'll see a tab titled "Schools". If you click on this, you'll be linked to a page where you can search for your school by name or search for it on a map.`,
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/SchoolProfile/TTHTSchoolProfileSection.consts.js